<template>
  <div class="spl-header-login-holder">
    <header class="spl-header-login">
      <div class="spl-header-login__logo" />
      <div class="spl-header-login__nav hide-on-mobile">
        <!--a href="" class="spl-header-login__nav__item">Dashboard</a-->
        <!--a href="" class="spl-header-login__nav__item">Partner</a>
                <a href="" class="spl-header-login__nav__item">Contact</a-->
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'MainHeaderLogin'
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-header-login-holder {
        height: $headerHeight;
        width: 100%;

        .spl-header-login {
            background-color: $mainInputColor;
            height: $headerHeight;
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 9000;

            &:after {
                clear: both;
                content: '';
                display: block;
                float: none;
            }
            &__logo {
                background-image: url(../../assets/logo.png);
                background-position: 20px center;
                background-repeat: no-repeat;
                float: left;
                height: $headerHeight;
                width: 195px;
            }
            &__nav {
                float: right;
                height: $headerHeight;

                &:after {
                    clear: both;
                    content: '';
                    display: block;
                    float: none;
                }
                &__item {
                    border-right: 1px solid $headerNavBorderColor;
                    color: $disabledYellow;
                    cursor: pointer;
                    float: left;
                    font-size: 16px;
                    font-weight: 600;
                    height: $headerHeight;
                    line-height: $headerHeight + 2px;
                    padding: 0 20px;
                    position: relative;
                    transition: all $shortTransition ease-in-out;

                    &:first-child {
                        border-left: 1px solid $headerNavBorderColor;
                    }
                    &:hover,
                    &-active {
                        background-color: rgba($yellowButtonLabelHover, 0.5);
                        border-color: transparent;
                        color: $headerNavHoverColor;
                    }
                }
            }
        }
    }
</style>
